import { skipToken } from "@reduxjs/toolkit/query/react";

import { DataSourceRegistryPath } from "@/features/data-source/data-source-registry";
import { GetDataSourceOptions } from "@/store/services/data-source.service";

const convertNullableParametersToStrings = (
    parameters?: Record<string, string | number | boolean | undefined | null>,
): Record<string, string | number | boolean> => {
    if (!parameters) return {};

    return Object.fromEntries(Object.entries(parameters).map(([key, value]) => [key, value ?? ""])) as Record<
        string,
        string | number | boolean
    >;
};

export const getDataSourceQueryArgs = (
    dataSourcePath: DataSourceRegistryPath,
    parameters?: Record<string, string | number | boolean>,
): GetDataSourceOptions | typeof skipToken => {
    return {
        apiVersion: "v2",
        path: dataSourcePath,
        parameters: convertNullableParametersToStrings(parameters),
    };
};
